import gql from 'graphql-tag';

export const getTableConfig = gql`
	query getTableConfig($tableType: TableTypeEnum!) {
		tableConfig(tableType: $tableType) {
			tableType
			columns {
				head
				type
				key
				isSortable
				customData
			}
			filtersConfig {
				name
				type
				columnName
			}
			isExportable
		}
	}
`;
